import SkillAbility from './model';

export default SkillAbility;



// WEBPACK FOOTER //
// ./data/IndividualDevelopmentPlans/OverallDevelopment/template/skills/abilities/index.js